import React from "react";

export interface IRHPPrompt {
  prompt: string;
  selectPrompt: (prompt: string) => void;
}

export const RHPPrompt = (props: IRHPPrompt) => {
  const { prompt, selectPrompt } = props;

  return (
    <div className="w-full px-15px py-10px font-pt-sans text-15px leading-[22px] border border-gray-20 cursor-pointer hover:bg-white-hard hover:shadow-[0px_2px_4px_-1px_rgba(15,23,42,0.06)] hover:shadow-[0px_4px_6px_-1px_rgba(15,23,42,0.10)] hover:shadow-[0px_0px_1px_0px_rgba(15,23,42,0.06)]" onClick={() => selectPrompt(prompt)}>
      {prompt}
    </div>
  );
}